module.exports = __webpack_public_path__ + "img/worm-die-mask.953a302b.png";